import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { callGetTicketMicroFront } from '../../services/TicketService';
function MicroFrontend({
  name,
  host,
  location,
  containerPath,
  containerState,
  catchError,
}) {
  useEffect(() => {
    const scriptId = `micro-frontend-script-${name}`;
    const renderMicroFrontend = () => {
      if (location) {
        window[`render${name}`](
          `${name}-container`,
          location,
          containerPath,
          containerState,
        );
      }
    };

    if (document.getElementById(scriptId)) {
      renderMicroFrontend();
      return;
    }

    callGetTicketMicroFront(host)
      .then((manifest) => {
        const script = document.createElement('script');
        script.id = scriptId;
        script.crossOrigin = '';
        script.src = `${host}${manifest.data.files['main.js']}`;
        script.onload = () => {
          renderMicroFrontend();
        };
        document.head.appendChild(script);
      })
      .catch(() => catchError());

    return () => {
      window[`unmount${name}`] && window[`unmount${name}`](`${name}-container`);
    };
  });

  return <main id={`${name}-container`} />;
}

MicroFrontend.defaultProps = {
  document,
  window,
};

MicroFrontend.propTypes = {
  name: PropTypes.string,
  host: PropTypes.string,
  location: PropTypes.string,
  containerPath: PropTypes.string,
  containerState: PropTypes.string,
  catchError: PropTypes.func,
};

export default MicroFrontend;
